import React, { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useParentAuth } from "../context/ParentAuthContext";
import { useData } from "../context/DataContext";
import { resolveImageUrl } from "../admin/ImageUpload";
import { toast } from "sonner";
import { LogIn, ArrowLeft } from "lucide-react";

const ParentLogin = () => {
  const { user, login } = useParentAuth();
  const { settings } = useData();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const logo = resolveImageUrl(settings?.logo);
  // Where to go after login (e.g. back to the shop cart). Read once, then cleared.
  const [redirectTo] = useState(() => localStorage.getItem("elan_shop_redirect") || "");

  useEffect(() => {
    if (redirectTo) localStorage.removeItem("elan_shop_redirect");
  }, [redirectTo]);

  if (user) return <Navigate to={redirectTo || "/espace-famille"} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      // La redirection est gérée par la branche `if (user)` ci-dessus (elle honore elan_shop_redirect)
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec de connexion");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <div className="py-5 px-6">
        <Link to="/" className="inline-flex items-center gap-1 text-stone-600 hover:text-deep-rose text-sm"><ArrowLeft size={14}/> Retour au site</Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-12">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 sm:p-10">
          <div className="text-center mb-8">
            {logo ? (
              <img src={logo} alt="L'Élan Danse" className="h-20 mx-auto object-contain" />
            ) : (
              <div className="flex flex-col leading-none items-center">
                <span className="font-script text-5xl text-deep-rose">L&apos;élan</span>
                <span className="font-script text-4xl text-deep-rose -mt-1">Danse</span>
              </div>
            )}
            <p className="mt-3 text-xs uppercase tracking-widest text-stone-500">Espace famille</p>
          </div>
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="block text-sm uppercase tracking-widest text-stone-500 mb-2">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" name="email" autoComplete="email" inputMode="email" required className="w-full bg-cream rounded-xl border border-blush-light px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blush" />
            </div>
            <div>
              <label className="block text-sm uppercase tracking-widest text-stone-500 mb-2">Mot de passe</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" name="current-password" autoComplete="current-password" required className="w-full bg-cream rounded-xl border border-blush-light px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blush" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-coral text-white py-3 rounded-full font-serif-display tracking-widest uppercase text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50">
              {loading ? "Connexion..." : (<><LogIn size={16}/> Se connecter</>)}
            </button>
            <div className="text-center">
              <Link to="/espace-famille/mot-de-passe-oublie" data-testid="parent-forgot-link" className="text-xs text-stone-500 hover:text-deep-rose underline">
                Mot de passe oublié&nbsp;?
              </Link>
            </div>
            <p className="text-center text-xs text-stone-500 mt-3">
              Pas encore de compte ? <Link to="/inscription" className="text-deep-rose underline">Inscrivez-vous</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ParentLogin;
